
import scrollTo from './../utility/scrollTo'

function elementWithinTag(element, tagName) {
    let parent = element
    while (parent !== null && parent.tagName !== tagName.toUpperCase()) {
        parent = parent.parentNode
    }
    return parent;
}

function isSamePage(href) {
	const splitHash = /^(.*)\#(.*)$/
	const current = window.location.origin + window.location.pathname
	const [string, location, hash] = href.match(splitHash) || []
	if (!location || !hash) return false
	return location === current
}

export default (offset = 0) => {
	document.addEventListener('click', event => {
		const link = elementWithinTag(event.target, 'a')
		if (!link || !isSamePage(link.href || '')) return
		const el = document.querySelector(link.hash)
		if (!el) return
		event.preventDefault()
		const shift = (typeof offset === 'function') ? offset() : offset
		scrollTo(el, shift)
	})
}